// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const { HYPHEN, BROKER_PRODUCT_TYPE_DERECHOS_ID } = require('constants/index');

/**
 * Get product description from id
 * @param {string | number} productId
 * @param {string} default If product wasn't found, use this
 * @returns {string}
 */
function getProductDescriptionById(productId, _default = HYPHEN) {
    switch (productId + '') {
        case BROKER_PRODUCT_TYPE_DERECHOS_ID:
            return formatText('broker-productTypeDerechos');
        default:
            return _default;
    }
}

module.exports = { getProductDescriptionById };
